import { registerQuery, registerSubscription } from '@adornis/baseql/metadata/register.js';
import { ExamSlotGroup } from '@ils/slots/db/examSlotGroup.js';
import {
  getExamSlotsGroupedByStartTimeResolver,
  subscribeExamSlotsGroupedByStartTimeResolver,
} from '@ils/slots/server/resolver/examSlotGroup.js';

export const getExamSlotsGroupedByStartTime = registerQuery({
  operationName: 'getExamSlotsGroupedByStartTime',
  resolve: getExamSlotsGroupedByStartTimeResolver,
  type: () => [ExamSlotGroup],
  params: [{ name: 'examDayID', type: () => String }],
  options: { requestHandlerMeta: { queryCache: { cachePolicy: 'bypass' } } },
});

export const subscribeExamSlotsGroupedByStartTime = registerSubscription({
  operationName: 'subscribeExamSlotsGroupedByStartTime',
  resolve: subscribeExamSlotsGroupedByStartTimeResolver,
  type: () => [ExamSlotGroup],
  params: [{ name: 'examDayID', type: () => String }],
});
